import { render } from "./CreateReportResponse.vue?vue&type=template&id=81551de4"
import script from "./CreateReportResponse.vue?vue&type=script&lang=js"
export * from "./CreateReportResponse.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2367962886/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__